import { render } from "./set_product_detail.vue?vue&type=template&id=504764ae"
import script from "./set_product_detail.vue?vue&type=script&setup=true&lang=js"
export * from "./set_product_detail.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/set_product_detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "504764ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('504764ae', __exports__)) {
    api.reload('504764ae', __exports__)
  }
  
  module.hot.accept("./set_product_detail.vue?vue&type=template&id=504764ae", () => {
    api.rerender('504764ae', render)
  })

}


export default __exports__